import React from 'react';
import type { GalleryImage } from '../../data/gallery';

/**
 * A collage: photographs tiled edge to edge, two of them twice the size of
 * the rest so the wall has a rhythm rather than reading as a contact sheet.
 *
 * No captions, no category labels, no lightbox — the pictures are the
 * content, and on a page that exists purely for looking at them, every
 * piece of chrome is something between the reader and the photograph. Alt
 * text still carries the description for anyone who cannot see them.
 */
export function GalleryGrid({
  images
}: {
  images: GalleryImage[];
}) {
  if (images.length === 0) return null;
  return <ul className="grid auto-rows-[9rem] grid-cols-2 gap-2 sm:auto-rows-[11rem] sm:grid-cols-4 lg:auto-rows-[13rem]" data-id="element-137" data-mp="3msf3c9xdnfxb">
      {images.map(image => <li key={image.id} className={image.feature ? 'col-span-2 row-span-2 overflow-hidden rounded-container' : 'overflow-hidden rounded-container'} data-id="element-138" data-mp="2ub2s9c2f64vs">
          <img src={image.src} alt={image.alt} loading="lazy" decoding="async" className="h-full w-full object-cover" data-id="element-139" data-mp="31hcloei6idrh" />
        </li>)}
    </ul>;
}